module.exports = __webpack_public_path__ + "media/src/images/features-03-2cf17acf6e265c60be43a9edc9b756e6.svg";